import type { RuleSet } from 'styled-components';
import styled, { css } from 'styled-components';
import { labelWithIconBaseStyles } from '@/app/components/search/components/Card/Details/Badges/LabelWithIcon/styled.ts';

export const LastMinuteDealsBadgeContainer = styled.div`
  ${labelWithIconBaseStyles};
  display: block;
  margin-bottom: 4px;
  text-align: right;
  padding-left: 0;
  padding-right: 0;

  span {
    flex-shrink: 0;
    vertical-align: top;
  }

  img {
    margin-top: 2px;
    margin-right: 4px;
    vertical-align: top;
  }
`;

export const TextContainer = styled.span<{ $icon: string; $color: string; $preset?: RuleSet<object> }>`
  ${(props) =>
    props.$preset
      ? props.$preset
      : css`
          ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};

          strong {
            font-size: 14px;
            line-height: 18px;
          }
        `};
  color: ${(props) => props.$color};

  strong {
    display: inline-flex;
    font-family: var(--font-lastminute-sans), sans-serif;
    font-weight: 400;
    position: relative;
    color: ${(props) => props.$color};

    ${({ $icon }) => css`
      &:after {
        content: '';
        position: absolute;
        top: unset;
        bottom: -2px;
        left: 0;
        right: 0;
        width: 100%;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center center;
        background-image: url(${$icon});
        height: 3px;
      }
    `};
  }
`;
